import React, {Component} from 'react';
import { Link } from "react-router-dom";
import Progress from "../../components/Progress/Progress";
import css from '../CustomerDetails/CustomerDetails.module.scss';
import formatShortDate from '../../utils/formatShortDate';
import axios from 'axios';
import {connect} from "react-redux";
import _ from 'lodash';
import AWS from 'aws-sdk';
import Modal from 'react-modal';
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronRight, faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { fetchS3Photos } from '../../utils/awsHelper';


const FieldCustomerDetails = class extends Component {
    oppId = this.props.match.params.id;
    source = axios.CancelToken.source();

    state = {
        workOrder: {},
        opportunity: {},
        jobOverview: {},
        serviceCase: {},
        workOrders: [],
        currentStageIndex: 0,
        progressStages: [],
        totalHours: 0,
        salesReps: [],
        designPermitDocs: [],
        showPendingWorkModal: false,
        pendingWorkChecklist: [], // [{"workTypesRequiredFor":[string], "rejectionNote":string, "label":string, "fieldHelpText":string, "checked":boolean, "apiName":string}]
        shouldDisableStartButton: false,
        showCompletedWorkOrders: true,
        visibleCompletedWorkOrders: [],
        latestWorkOrder: {}
    };

    async componentDidMount() {
        window.scrollTo(0, 0);
        this.getOpportunity();
        await this.getDocs();
    };

    componentWillUnmount() {
        this.source.cancel();
    };

    getOpportunity = async () => {
        const oppPost = {
            "limit": 1,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Internal_Stage__c",
                "StageName",
                "Status__c",
                "Sub_Status_new__c",
                "Install_Complete__c",
                "Inspection_Passed__c",
                "PTO_Granted__c",
                "Street__c",
                "City__c",
                "State__c",
                "Zip__c",
                "Any_Code_Gates_Animals__c",
                "SS_Dropbox_Link__c",
                "Notes_for_Field__c",
                "Active_Post_Proposal__c",
                "Active_Post_Proposal__r.PCS_Conductor_Limit_A__c",
                "Active_Post_Proposal__r.System_Size__c",
                "Active_Post_Proposal__r.Post_Panel_Count__c",
                "Active_Post_Proposal__r.Battery_Type__c",
                "Active_Post_Proposal__r.Battery_Type__r.Name",
                "Active_Post_Proposal__r.Number_of_Batteries__c",
                "Active_Site_Assessment__c",
                "Active_Site_Assessment__r.Export_Limit__c",
                "Jurisdiction_opp__c",
                "Jurisdiction_opp__r.Field_Notes__c",
                "Sales_Representative__c",
                "Sales_Representative__r.Name",
                "Sales_Representative__r.Phone",
                "Sales_Representative_2__c",
                "Sales_Representative_2__r.Name",
                "Sales_Representative_2__r.Phone",
                "Sales_Representative_3__c",
                "Sales_Representative_3__r.Name",
                "Sales_Representative_3__r.Phone"
            ],
            "where": {
                "Id": this.oppId
            }
        };

        await axios.post(
            '/sf/opportunity/findNo',
            oppPost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const data = res.data.records[0];
                const salesReps = [];
                if (data?.Sales_Representative__r) salesReps.push(data.Sales_Representative__r);
                if (data?.Sales_Representative_2__r) salesReps.push(data.Sales_Representative_2__r);
                if (data?.Sales_Representative_3__r) salesReps.push(data.Sales_Representative_3__r);

                this.setState({opportunity: data, salesReps});
                // this.configureAWS();
                this.getRecords();
            })
            .catch(err => console.log('(POST) Error For Opportunity: ', err));
    };

    getRecords = async () => {
        const woPost = {
            "limit": 1000,
            "skip": 0,
            "fields": [
                "Id",
                "Name",
                "Date__c",
                "Status__c",
                "Review_Result__c",
                "Work_Types__c",
                "Job_Overview__c",
                "Job_Overview__r.Work_Types__c",
                "Job_Overview__r.Stage__c",
                "Regular_Hours__c",
                "OT_Hours__c",
                "Clocked_End__c",
                "Opportunity__c",
                "Assigned_Field_Team__c",
                "Assigned_Field_Team__r.Name",
                "Assigned_Field_Team__r.Tech_1__c",
                "Assigned_Field_Team__r.Tech_2__c",
                "Assigned_Field_Team__r.Tech_3__c",
                "Assigned_Field_Team_2__c",
                "Assigned_Field_Team_2__r.Name",
                "Assigned_Field_Team_2__r.Tech_1__c",
                "Assigned_Field_Team_2__r.Tech_2__c",
                "Assigned_Field_Team_2__r.Tech_3__c",
                "Outcome__c",
                "Job_Notes__c",
                "Electrical_Notes__c",
                "EOD_Notes__c",
            ],
            "where": {
                "Opportunity__c": this.state.opportunity.Id
            }
        };
        
        await axios.post(
            '/sf/WorkOrder/findNo',
            woPost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const workOrders = res.data.records;
                const sortedData = _.orderBy(workOrders, ['Date__c'], ['desc']);
                let totalHours = 0;

                _.forEach(workOrders, function(order) {
                    const regular = order.Regular_Hours__c || 0;
                    const ot = order.OT_Hours__c || 0;
                    totalHours += regular + ot;
                })

                const completed = sortedData
                    .filter(wo => wo.Clocked_End__c)
                    .map(wo => {
                        const workTypes = wo.Work_Types__c ? wo.Work_Types__c.replaceAll(';', ', ') : '';
                        const name = `${formatShortDate(wo.Date__c)} - ${workTypes}`;

                        let isPartOfFieldTeam = false;
                        const fieldTeamMembers = [];
                        if(wo.Assigned_Field_Team__c){
                            fieldTeamMembers.push(wo.Assigned_Field_Team__r.Tech_1__c, wo.Assigned_Field_Team__r.Tech_2__c, wo.Assigned_Field_Team__r.Tech_3__c);
                        }
                        if(wo.Assigned_Field_Team_2__c){
                            fieldTeamMembers.push(wo.Assigned_Field_Team_2__r.Tech_1__c, wo.Assigned_Field_Team_2__r.Tech_2__c, wo.Assigned_Field_Team_2__r.Tech_3__c);
                        }
                        if(fieldTeamMembers.includes(this.props.user.apiId)){
                            isPartOfFieldTeam = true;
                        }

                        return {
                            id: wo.Id,
                            extended: false,
                            name,
                            data: wo,
                            showEditButton: isPartOfFieldTeam,
                        };
                    });

                this.setState({
                    workOrders: sortedData,
                    totalHours: totalHours,
                    visibleCompletedWorkOrders: completed,
                    latestWorkOrder: sortedData && sortedData.length > 0 ? sortedData[0] : {}
                });
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in Work Orders:\n', err);
                }
            });

        const casePost = {
            "limit": 1,
            "skip": 0,
            "fields": [
                "Id",
                "Subject",
            ],
            "where": {
                "Status":{$ne: 'Cancelled'},
                "Status":{$ne: 'Closed'},
                "Opportunity__c": this.state.opportunity.Id,
                "RecordTypeId": "0121N000001Atu6",
            }
        };
        
        await axios.post(
            '/sf/case/findNo',
            casePost,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const cases = res.data.records;
                this.setState({serviceCase: cases[0]});
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    console.log('Request canceled');
                } else {
                    console.log('(GET) Error in Cases:\n', err);
                }
            });
        
        await axios.get(
            '/sf/opportunity/describeField/Internal_Stage__c;',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                const currentProgressStage = this.state.opportunity.Internal_Stage__c;
                const progressStages = resPickFields.data.Internal_Stage__c.picklistValues
                    .map(stage => stage.value);

                const currentStageIndex = progressStages.indexOf(currentProgressStage);

                this.setState({
                    progressStages,
                    currentStageIndex,
                });
            })
            .catch(err => console.log('(Get) Error Opportunity Internal Stage: \n', err));
    };

    getDocs = async() => {
        const keys = {};
            fetchS3Photos({
                recordId: this.oppId,
                type: '006-opportunity',
                existingState: keys,
                source: this.source,
                process: 'getRepUploads'
            })
            .then(returnedFiles => {
                let docs = [];
                
                Object.keys(returnedFiles).map(doc =>{
                    if(returnedFiles[doc] === 'Design Plans' || returnedFiles[doc] === 'Permit'){
                        const parts = doc.split('/');
                        const docName = parts[parts.length - 1];
                        docs.push({name: docName, key: 'https://v3-salesforce-file-storage.s3.us-west-2.amazonaws.com/' + doc});
                    }
                })

                this.setState({designPermitDocs: docs});
            })
            .catch(err => {
                console.error('AWS S3 fetch error:', err);
                this.setState({ errorMessage: err.message });
            });
    }

    pendingWork = () => {
        this.setState({showPendingWorkModal: true});
        
        if(this.state.workOrders && this.state.workOrders.length > 0) {
            const wo = _.find(this.state.workOrders, function(wo) {
                return wo.Job_Overview__r.Stage__c === 'Install';
            });

            if(wo) {
                let payload = {
                    TypeOfLead: 'PendingWork',
                    Id: wo.Id
                }

                if(!this.state.pendingWorkChecklist.length){
                    axios.post('/leadPost', payload, {cancelToken: this.source.token}).then((res) => {
                        const checkboxes = res.data;
                        const pendingWorkChecklist = checkboxes.filter(cb => !cb.checked);
                        this.setState({pendingWorkChecklist});
                    }).catch(err => {
                        console.log('Error Receiving Pending Work Checkboxes :\n', err)
                    })
                }
            }
        }
    };

    toggleVisibleCompletedWorkOrder = (woId) => {
        this.setState(prev => ({
            visibleCompletedWorkOrders: prev.visibleCompletedWorkOrders.map(wo =>
                wo.id === woId ? { ...wo, extended: !wo.extended } : wo
            )
        }));
    };

    render() {
        return (
            <div>
                <div className={css.CustomerDetails}>
                    {/* ---------- header info: ---------- */}
                    <div className="row">
                        {/* ----- row 1: ----- */}
                        <div className="col-12 col-md-6 mb-2">
                            <h4>name</h4>
                            <h1>{this.state.opportunity.Name}</h1>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                            <h4>work types</h4>
                            <h1 className="break-words whitespace-normal max-w-[300px]">
                                {this.state.latestWorkOrder && this.state.latestWorkOrder.Job_Overview__r?.Work_Types__c
                                    ? this.state.workOrders[0].Job_Overview__r.Work_Types__c.replace(/;/g, ' - ')
                                    : '---'}
                            </h1>
                        </div>
    
                        {/* ----- row 2: ----- */}
                        <div className="col-12 col-md-6 mb-2">
                            <h4>initial work order date</h4>
                            <h1>
                                {this.state.workOrders && this.state.workOrders.length > 0
                                ? formatShortDate(this.state.workOrders[this.state.workOrders.length - 1].Date__c)
                                : '---'}
                            </h1>
                        </div>
                        <div className="col-12 col-md-6 mb-2">
                            <h4>latest work order date</h4>
                            <h1>
                                {this.state.latestWorkOrder
                                ? formatShortDate(this.state.latestWorkOrder.Date__c)
                                : '---'}
                            </h1>
                        </div>
    
                        {/* ----- row 3: ----- */}
                        <div className="col-12 col-md-3 mb-2">
                            <h4>stage</h4>
                            <h1>{this.state.opportunity.Internal_Stage__c}</h1>
                        </div>
                        <div className="col-12 col-md-3 mb-2">
                            <h4>milestone</h4>
                            <h1>{this.state.opportunity.StageName}</h1>
                        </div>
                        <div className="col-12 col-md-3 mb-2">
                            <h4>status</h4>
                            <h1>{this.state.opportunity.Status__c}</h1>
                        </div>
                        <div className="col-12 col-md-3 mb-2">
                            <h4>Sub Status</h4>
                            <h1>{this.state.opportunity.Sub_Status_new__c ? this.state.opportunity.Sub_Status_new__c : '---'}</h1>
                        </div>

                        {/* progress steps:: */}
                        <Progress currentStageIndex={this.state.currentStageIndex} stages={this.state.progressStages} />
                    </div>
                    {/* End of Header Info */}

                    <div className={`${css.CustomerDetails__Main} mt-3`}>
                        <div className="text-center d-flex flex-column d-sm-block">
                            
                            <Link to={`/photoPack/install/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Install Photo Pack</button>
                            </Link>
                            <Link to={`/photoPack/electrical/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Solar Electrical Photo Pack</button>
                            </Link>
                            <Link to={`/photoPack/battery/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Battery Photo Pack</button>
                            </Link>

                            <div className="d-none d-sm-block"><br/></div>
                            <Link to={`/photoPack/serviceCall/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Service Call Photo Pack</button>
                            </Link>
                            <Link to={`/photoPack/mpu/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">MPU Photo Pack</button>
                            </Link>
                            <Link to={`/photoPack/miscElectrical/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Misc Electrical Photo Pack</button>
                            </Link>

                            <div className="d-none d-sm-block"><br/></div>
                            <Link to={`/photoPack/inspection/${this.state.latestWorkOrder?.Id}/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Inspection Photo Pack</button>
                            </Link>
                           
                            <Link to={`/existingPhotos/${this.state.opportunity.Id}`}>
                                <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto" type="button">Existing Photos</button>
                            </Link>
                            <button className="btn btn-primary ml-sm-2 mt-3 mt-sm-0 w-100 w-sm-auto"  type="button" onClick={() => this.pendingWork()}>Pending Work</button>
                        </div>

                        <div className="mt-5">
                            <h2>Field Team Details</h2>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.workOrders && this.state.workOrders.length > 0 ? this.state.workOrders[0].Review_Result__c : '---'}</div>
                                    <div className="text-sm">RTR Result</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.Install_Complete__c}</div>
                                    <div className="text-sm">Install Complete Date</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.Inspection_Passed__c}</div>
                                    <div className="text-sm">Inspection Passed Date</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.PTO_Granted__c}</div>
                                    <div className="text-sm">PTO Granted</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.serviceCase?.Subject ? this.state.serviceCase.Subject : '---'}</div>
                                    <div className="text-sm">Open Service Call</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{(this.state.totalHours).toFixed(2)}</div>
                                    <div className="text-sm">Total Hours</div>
                                </div>
                            </div>
                        </div>

                        <div className="mt-5">
                            <h2>Customer Details</h2>
                            <div className="row">
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}><a className='text-primary' href={`https://www.google.com/maps/place/${this.state.opportunity.Street__c}+${this.state.opportunity.City__c}+${this.state.opportunity.State__c}+${this.state.opportunity.Zip__c}`} target="_blank" rel="noreferrer noopener">{this.state.opportunity.Street__c}</a></div>
                                    <div className="text-sm">Street</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.City__c}</div>
                                    <div className="text-sm">City</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.State__c}</div>
                                    <div className="text-sm">State</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.Zip__c}</div>
                                    <div className="text-sm">Zip Code</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                        {this.state.opportunity.Active_Post_Proposal__r ? this.state.opportunity.Active_Post_Proposal__r.System_Size__c : '---'}
                                    </div>
                                    <div className="text-sm">System Size</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                        {this.state.opportunity.Active_Post_Proposal__r ? this.state.opportunity.Active_Post_Proposal__r.Post_Panel_Count__c : '---'}
                                    </div>
                                    <div className="text-sm">Number of Panels</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                        {this.state.opportunity.Active_Post_Proposal__r ? this.state.opportunity.Active_Post_Proposal__r.Battery_Type__r?.Name : '---'}
                                    </div>
                                    <div className="text-sm">Battery Type</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                        {this.state.opportunity.Active_Post_Proposal__r ? this.state.opportunity.Active_Post_Proposal__r.Number_of_Batteries__c : '---'}
                                    </div>
                                    <div className="text-sm">Number of Batteries</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                        {this.state.opportunity.Active_Post_Proposal__r ? this.state.opportunity.Active_Post_Proposal__r.PCS_Conductor_Limit_A__c : '---'}
                                    </div>
                                    <div className="text-sm">MSP Export Limit</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>
                                        {this.state.opportunity.Active_Site_Assessment__r ? this.state.opportunity.Active_Site_Assessment__r.Export_Limit__c : '---'}
                                    </div>
                                    <div className="text-sm">Site Export Limit</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}>{this.state.opportunity.Any_Code_Gates_Animals__c}</div>
                                    <div className="text-sm">CU Preferences/Access Info</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}><a className='text-primary' href={this.state.opportunity.SS_Dropbox_Link__c}>{this.state.opportunity.SS_Dropbox_Link__c ? 'Link' : ''}</a></div>
                                    <div className="text-sm">Old Jobsite Photos Link</div>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold break-words whitespace-normal`}>
                                        {this.state.opportunity.Jurisdiction_opp__r ? <textarea readOnly rows="8" value={this.state.opportunity.Jurisdiction_opp__r.Field_Notes__c}/> : '---'}
                                    </div>
                                    <div className="text-sm">Jurisdiction Field Notes</div>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <div className={`${css.CustomerDetails__Field} font-weight-bold`}><textarea rows="8" value={this.state.opportunity.Notes_for_Field__c}/></div>
                                    <div className="text-sm">Notes for Field</div>
                                </div>
                            </div>
                        </div>
                        {/* End of Customer Details */}

                        {/* Sales Representatives */}
                        <div className="mt-5">
                            <h2>Sales Representatives</h2>
                            <table className="w-full table-auto border-collapse">
                                <tbody>
                                {
                                    this.state.salesReps.map((rep, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{rep.Name}</td>
                                                <td className="font-weight-bold">
                                                    <span className={rep.Phone ? '' : 'd-none'}>
                                                        <a href={`tel:${rep.Phone}`}>{rep.Phone}</a>
                                                    </span>
                                                    <span className={rep.Phone ? 'd-none' : ''}>NO PHONE NUMBER</span>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                        {/* End Sales Representatives */}

                        {/* Design Plans and Permits */}
                        <div className="mt-5">
                            <h2>Design Plans & Permits</h2>
                            <table className="w-full table-auto border-collapse">
                                <tbody>
                                {
                                    this.state.designPermitDocs.map((doc, index) => {
                                        return (
                                            <tr key={index} className="border-b">
                                                <td className="p-2 break-words whitespace-normal max-w-[300px]">
                                                    {doc.name.replace(/_/g, ' ')}
                                                </td>
                                                <td  className="p-2 font-bold text-blue-600">
                                                    <a href={doc.key} target="_blank">Link To Doc</a>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                                </tbody>
                            </table>
                        </div>
                        {/* End of Design Plans and Permits */}

                        {/* Completed Work Orders */}
                        <h2 className="mt-4" onClick={() => this.setState({ showCompletedWorkOrders: !this.state.showCompletedWorkOrders })} style={{ cursor: 'pointer' }}>
                            Completed Work Orders <FontAwesomeIcon className="text-primary" icon={this.state.showCompletedWorkOrders ? faCaretDown : faCaretUp}/>
                        </h2>
                        <div className={this.state.showCompletedWorkOrders ? "" : 'd-none'}>
                            {this.state.visibleCompletedWorkOrders.map((wo) => {
                                return (
                                    <div className="p-2 border rounded" id={wo.id} key={wo.id}>
                                        <h2 onClick={() => this.toggleVisibleCompletedWorkOrder(wo.id)} style={{ cursor: 'pointer' }}>
                                            <FontAwesomeIcon className="text-primary" icon={wo.extended ?  faChevronDown : faChevronRight} />
                                            {' '}{wo.name}
                                        </h2>
                                        {wo.extended && (
                                            <div>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="w-50">Field Team</td>
                                                            <td className="w-50 font-weight-bold">
                                                                {wo.data.Assigned_Field_Team__r?.Name ?? "---"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="w-50">Field Team 2</td>
                                                            <td className="w-50 font-weight-bold">
                                                                {wo.data.Assigned_Field_Team_2__r?.Name ?? "---"}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="w-50">Outcome</td>
                                                            <td className="w-50 font-weight-bold">
                                                                {wo.data.Outcome__c ?? "---"}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div className="row">
                                                    <div className="col-md-6 mt-3">
                                                        <div className={`${css.CustomerDetails__Field} font-weight-bold break-words whitespace-normal`}>
                                                            <textarea rows="6" value={wo.data.Job_Notes__c} disabled/>
                                                        </div>
                                                        <div className="text-sm">Job Notes</div>
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <div className={`${css.CustomerDetails__Field} font-weight-bold break-words whitespace-normal`}>
                                                            <textarea rows="6" value={wo.data.Electrical_Notes__c} disabled/>
                                                        </div>
                                                        <div className="text-sm">Electrical Notes</div>
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <div className={`${css.CustomerDetails__Field} font-weight-bold break-words whitespace-normal`}>
                                                            <textarea rows="6" value={wo.data.EOD_Notes__c} disabled/>
                                                        </div>
                                                        <div className="text-sm">EOD Notes</div>
                                                    </div>
                                                </div>
                                                {wo.showEditButton && (
                                                    <Link to={`/workOrderForm/${wo.id}`}>
                                                        <button className="btn btn-primary w-100 text-md mt-3" type="button">Edit Job</button>
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>

                {/* ---------- Pending Work Modal: ---------- */}
                <Modal
                    isOpen={this.state.showPendingWorkModal}
                    onRequestClose={() => this.setState({showPendingWorkModal: false})}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            maxHeight: 'calc(70vh - 2rem)',
                            background: 'rgba(53, 53, 53)'
                        }
                    }}
                >
                    <div className="mt-2 text-center text-white">
                        <h2>Pending Work</h2>
                        
                        {this.state.pendingWorkChecklist.map(checkbox => (
                            <div key={checkbox.apiName} style={{display:"flex", justifyContent:"flex-start", borderRadius:"4px",padding:"6px", fontSize: window.innerWidth <= 768 ? "12px" : "16px", textAlign: "left"}}>
                                <label style={{flex: "0 0 45%", fontWeight:"bold", marginRight:"8px", borderLeft:"2px solid #c9c9c9", paddingLeft:"8px"}}>
                                    {checkbox.label}
                                </label>

                                <span style={{ marginLeft: "2px", fontStyle: "italic"}}>
                                    {checkbox.rejectionNote}
                                </span>
                            </div>
                        ))}
                        <button className="btn btn-primary" type="button" onClick={() => this.setState({showPendingWorkModal: false})}>Close</button>&nbsp;
                    </div>
                </Modal>
            </div>
        );
    };
};

const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(FieldCustomerDetails);